import React from "react";

export default function CopyStep9() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          9
        </div>
        <h1 className="">
          Agora, <b>clique no seu perfil/número de conta</b> e em seguida{" "}
          <b>clique em DEPOSITAR</b>.
        </h1>
      </div>
      <div className="ml-[42px] flex flex-col gap-2.5">
        <p>
          Faça um depósito de <b>pelo menos 50 dólares</b> (valor mínimo exigido
          pela XM para estratégias automatizadas).
        </p>
        <p>
          O depósito pode ser realizado via <b>Pix ou Cartão de Crédito</b>.
        </p>
        <p className="underline">
          Note que quanto maior o valor investido, maiores serão os resultados.
        </p>
        <img
          src="https://media.atomicatpages.net/u/0BVrOWOoOHYYehGtCMVYjXF1KZk1/Pictures/6f5kr/n2l5x/lqibfn2536070.jpeg"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
